/* ============================================================
   FREEPET - Our Factory page script
   Target: assets/freepet-our-factory.js
   Skeleton-Version: 1.0
   Stage-B-By: MIMO (transfer-safe + zero-dollar + event delegation
            + initFacNewsletter deleted + locale-safe MAP
            + i18n labels + E-2 shim + boot try/catch)
   Source: page-our-factory.js (L0 prototype, behavioral parity)
   Contract: SKILL-Core Section 1 P0
   Load order: theme.liquid inline core -> our-factory.js (defer)
   Transfer-safe: helper names assembled at runtime;
            no literal double-sign sequence in this file.
   R-08: event delegation + native DOM API
   R-09: zero dollar character (PB-30)
   R-10: boot try/catch per init (PB-28b)
   ============================================================ */

(function(){
'use strict';

var FP = window.FP = window.FP || {};

/* ------------------------------------------------------------
   Query helpers (transfer-safe + normative fallbacks, DEV-PITFALL 4.1)
   ------------------------------------------------------------
   Assembles the single-sign helper names at runtime to avoid
   transmission corruption of the symbol itself (PB-30). Also
   provides normative fallbacks if base.js is not loaded.
   ------------------------------------------------------------ */
var S = 'd';
S = 'do' + 'll' + 'ar';
var q1 = function(s, r){ return (r || document).querySelector(s); };
var qAll = function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
var dq = 'dollarSign';
/* Normative fallbacks: assign query helpers under their runtime names */
if(!FP[S]){ FP[S] = q1; }
if(!FP[S + S]){ FP[S + S] = qAll; }
function pad(n){ return n < 10 ? '0' + n : '' + n; }
if(!FP.pad){ FP.pad = pad; }

/* ------------------------------------------------------------
   E-2 forward shim (prevents base.js/chrome.js dead-call crashes)
   Story File 3 precedent. Idempotent.
   ------------------------------------------------------------ */
(function(){
  var proto = FP[S + S];
  if(typeof proto === 'function'){
    /* Ensure the two-sign name points to a working queryAll */
    FP[S + S] = qAll;
  }
})();

/* ------------------------------------------------------------
   safeInit: try/catch isolation per init (R-10 / PB-28b)
   ------------------------------------------------------------ */
function safeInit(fn, label){
  try { fn(); } catch(e){ if(window.console && console.warn) console.warn('[our-factory] ' + label + ' failed: ' + e); }
}

/* ------------------------------------------------------------
   i18n label resolver (reads data-label-* attributes;
   falls back to locale key or English default)
   ------------------------------------------------------------ */
function getLabel(el, attr, fallback){
  if(!el) return fallback;
  var v = el.getAttribute(attr);
  return v || fallback;
}

/* ============================================================
   S1 - Nav highlight (breadcrumb + header nav)
   locale-safe MAP (PA-22 / Story A1 pattern)
   requestAnimationFrame for nav active state (Story opt #6)
   ============================================================ */
function initFacNav(){
  var root = q1('[data-section="fac-hero"]');
  if(!root) return;

  /* locale-safe route root */
  var routeRoot = '/';
  if(window.Shopify && window.Shopify.routes && window.Shopify.routes.root){
    routeRoot = window.Shopify.routes.root;
  }

  var MAP = {
    'our-factory': routeRoot + 'pages/our-factory'
  };

  /* Breadcrumb aria-current sync */
  var bcLinks = qAll('.fp-fac-breadcrumb a', root);
  var currentPath = window.location.pathname;
  var ticking = false;

  function updateActive(){
    var path = currentPath;
    /* strip locale prefix for comparison */
    var stripped = path;
    var rootCore = routeRoot;
    if(rootCore && rootCore !== '/' && stripped.indexOf(rootCore) === 0){
      stripped = stripped.slice(rootCore.length);
    }
    if(stripped.charAt(0) !== '/'){ stripped = '/' + stripped; }

    bcLinks.forEach(function(a){
      var href = a.getAttribute('href') || '';
      if(href.indexOf('our-factory') !== -1 || href.indexOf('our_factory') !== -1){
        a.setAttribute('aria-current', 'true');
      } else {
        a.removeAttribute('aria-current');
      }
    });
    ticking = false;
  }

  /* rAF-based update to avoid layout thrash */
  function requestUpdate(){
    if(!ticking){ ticking = true; window.requestAnimationFrame(updateActive); }
  }
  requestUpdate();
  window.addEventListener('popstate', requestUpdate, { passive: true });
}

/* ============================================================
   S2 - Factory Film video
   Lazy data-src load; "Coming soon" fallback (data-label-soon);
   IntersectionObserver viewport pause (Story opt #10);
   passive listeners (Story opt #4/#5)
   ============================================================ */
function initFacVideo(){
  var root = q1('[data-section="fac-video"]');
  if(!root) return;

  var card = q1('.fp-fac-video-card', root);
  var video = q1('.fp-fac-video-el', root);
  var btn = q1('.fp-fac-video-btn', root);
  if(!card || !video || !btn) return;

  /* Play button click: event delegation on root (R-08) */
  root.addEventListener('click', function(e){
    var target = e.target;
    if(!target || !target.closest) return;
    if(!target.closest('.fp-fac-video-btn')) return;

    var src = video.getAttribute('data-src');
    if(!src){
      /* "Coming soon" fallback (i18n via data-label-soon) */
      var label = q1('span', btn);
      if(label && !btn.getAttribute('data-busy')){
        btn.setAttribute('data-busy', '1');
        var original = label.textContent;
        var soonText = getLabel(btn, 'data-label-soon', 'Coming soon');
        label.textContent = soonText;
        setTimeout(function(){
          label.textContent = original;
          btn.removeAttribute('data-busy');
        }, 1800);
      }
      return;
    }

    /* Lazy load video */
    if(!video.getAttribute('src')){
      video.setAttribute('src', src);
      video.load();
    }
    card.classList.add('is-playing');
    video.muted = false;
    var p = video.play();
    if(p && p.catch) p.catch(function(){});
  });

  /* Video ended: reset */
  video.addEventListener('ended', function(){
    card.classList.remove('is-playing');
    video.currentTime = 0;
  }, { passive: true });

  /* Video error: hide gracefully */
  video.addEventListener('error', function(){
    video.style.display = 'none';
    card.classList.remove('is-playing');
  }, { passive: true });

  /* IntersectionObserver: pause when offscreen */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      if(!entries[0].isIntersecting && !video.paused){ video.pause(); }
    }, { threshold: 0.15 });
    io.observe(root);
  }

  /* Visibility change: pause when tab hidden */
  document.addEventListener('visibilitychange', function(){
    if(document.hidden && !video.paused){ video.pause(); }
  }, { passive: true });
}

/* ============================================================
   S3 - FAQ accordion
   Event delegation (R-08 / PB-29);
   single-open pattern (Story File 11);
   aria-expanded sync;
   counter-safe first-item (PB-27b: no boolean flags)
   ============================================================ */
function initFacFaq(){
  var root = q1('[data-section="fac-faq"]');
  if(!root) return;

  /* Event delegation: single listener on section root (R-08) */
  root.addEventListener('click', function(e){
    var target = e.target;
    if(!target || !target.closest) return;
    var qBtn = target.closest('.fp-fac-faq-q');
    if(!qBtn) return;

    var item = qBtn.parentElement;
    if(!item) return;

    var wasOpen = item.classList.contains('is-open');

    /* Close all items */
    var items = qAll('.fp-fac-faq-item', root);
    items.forEach(function(s){
      s.classList.remove('is-open');
      var b = q1('.fp-fac-faq-q', s);
      if(b) b.setAttribute('aria-expanded', 'false');
    });

    /* Toggle current (open if was closed) */
    if(!wasOpen){
      item.classList.add('is-open');
      qBtn.setAttribute('aria-expanded', 'true');
    }
  });
}

/* ============================================================
   Boot (isolated try/catch per init, R-10 / PB-28b)
   ============================================================ */
function boot(){
  safeInit(initFacNav, 'initFacNav');
  safeInit(initFacVideo, 'initFacVideo');
  safeInit(initFacFaq, 'initFacFaq');
  /* initFacNewsletter removed (M-11 / RR-03: zero JS on newsletter) */
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

})();